import { SafeAreaProvider } from 'react-native-safe-area-context';
import { APIProvider } from './APIContext';
import { GeoProvider } from './GeoContext';
import { JourneyProvider } from './JourneyContext';
import { MediaPlayerProvider } from './MediaPlayerContext';
import { StorageProvider } from './StorageContext';

// Combined provider that wraps all contexts
const AppProviders = ({ children }) => {
  return (
    <SafeAreaProvider>
      <StorageProvider>
        <GeoProvider>
          <APIProvider>
            <JourneyProvider>
              <MediaPlayerProvider>
                {children}
              </MediaPlayerProvider>
            </JourneyProvider>
          </APIProvider>
        </GeoProvider>
      </StorageProvider>
    </SafeAreaProvider>
  );
};

export default AppProviders;

// Export individual providers and hooks for convenience
export { APIProvider, useAPI } from './APIContext';
export { GeoProvider, useGeo } from './GeoContext';
export { JourneyProvider, useJourney } from './JourneyContext';
export { MediaPlayerProvider, useMediaPlayer } from './MediaPlayerContext';
export { StorageProvider, useStorage } from './StorageContext';

